module.exports = __webpack_public_path__ + "img/2002_S.29d740f1.png";